module.exports = __webpack_public_path__ + "img/logoOptia.0a5dae5c.png";